export default __webpack_public_path__ + "static/media/staticlunge.3167e7ba.png";